/* Inside the app.
 *
 * The phone app opens one page of this web app inside itself — the live
 * studio, which needs the browser's camera and recorder. There the page is
 * all there is: the app has its own navigation around it, and a second set
 * of menus inside would lead off into a web app the person did not open.
 *
 * Set by the hand-off page, for the life of that screen (sessionStorage),
 * so an ordinary browser tab is never affected.
 */
const KEY = 'cig.embedded'

export function isEmbedded(): boolean {
  try {
    return sessionStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function markEmbedded(): void {
  try {
    sessionStorage.setItem(KEY, '1')
  } catch {
    // Storage blocked: the page still works, with its menus showing.
  }
}
